import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectModel({ projectModel, select }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.projectModel}>
      <p className={styles.name}>{projectModel.name}</p>
      <Button className={styles.button} press={select}>
        {t("projectCreationFromModel.use")}
      </Button>
    </div>
  );
}

export { ProjectModel };
